import React from 'react';
import AppBaseComponent from '../../../components/AppBaseComponent';
import { connect } from 'react-redux';
import Ax from '../../../components/hoc/Ax';
import Loader from '../../../components/ui/Loader/Loader';
import HttpAPICall from '../../../services/HttpAPICall';
import { IAM_API_BASE_URL_2, IAM_SUBASSEMBLY_URL } from '../../../services/TapApiUrls';
import Status from '../../../components/ui/Status';
import { toast } from 'react-toastify';
import TapIcon from '../../../services/TapIcon';
import {Link} from "react-router-dom";
import swal from 'sweetalert';
import DateService from '../../../services/DateService';
import { Modal } from 'bootstrap';
import SubAssemblyDocumentModal from './SubAssemblyDocumentModal';
import moment from 'moment';
import LinkingModal from './LinkingModal';
import { DisplayListPagination } from '../../../components/TapUi';
import TicketTransactionList from '../../transactions/ticketTransaction/TicketTransactionList';
import ProcurementTab from '../../transactions/ticketTransaction/ProcurementTab';
import ConsumptionCycleTab from '../../transactions/ticketTransaction/ConsumptionCycleTab';
import ConsumptionCycleTabContainer from '../../transactions/ticketTransaction/ConsumptionCycleTabContainer';

class SubAssemblyDetail extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.state              =   {
            loadingDetail           :   false,
            viewSubAssemblyDetail   :   null,
            detailShow              :   false,
            siteTransitionShow      :   false,
            site_listing_loading    :   false,
            siteTransitionList      :   [],
            siteTransitionLoaded    :   false,
            subAssemblyId           :   '',
            assetLinkingLoaded      :   false,
            asset_linking_loading   :   false,
            asset_linking_data      :   [],
            currentTab              :   "detail",
            linkedAssetDetail        :   null,
            loadingAssetDetail       :   false,
            dashboard_loading       :   false,
            widgetData              :   null,
            assetLinkingMeta        :   null,
            ticket_loading          :   false,
            procurement_loading     :   false,
            ticketTabShow           :   false,
            procurementTabShow      :   false,
            assetTabShow            :   false,
            siteTabShow             :   false,
            dashboardTabShow        :   false,
            consumption_loading     :   false,
            consumptionTabShow      :   false,
            
        }
 
        this.documentModalRef       =   React.createRef();
        this.linkAssetModalRef      =   React.createRef();
        this.ticketVoucherBtnRef    =   React.createRef();
        this.procurementVoucherBtnRef = React.createRef();
        this.consumptionVoucherBtnRef = React.createRef();
        this.assetVoucherBtnRef     =   React.createRef();
        this.siteVoucherBtnRef      =   React.createRef();
        this.dashboardVoucherBtnRef =   React.createRef();

    }

    componentDidMount() { 
        this.linkedAssetDetailModal         =    new Modal(document.getElementById('linkedAssetDetailModal'), {keyboard: false, backdrop :false});
        if(this.props.subAssemblyId) {
            this.subAssemblyDetail(this.props.subAssemblyId);
            this.getDashboardDetail(this.props.subAssemblyId);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.subAssemblyId !== this.props.subAssemblyId && this.props.subAssemblyId) {
            this.setState({
                siteTransitionLoaded: false,
                assetLinkingLoaded: false,
                ticketTabShow: false,
                procurementTabShow: false,
                consumptionTabShow:false,
                assetTabShow: false,
                siteTabShow: false,
                dashboardTabShow: true, 
                viewSubAssemblyDetail: null, 
                widgetData: null,
                siteTransitionList: [],
                asset_linking_data: [],
            }, () => {
                this.subAssemblyDetail(this.props.subAssemblyId);
                this.getDashboardDetail(this.props.subAssemblyId);
            });
        }
    }
    getDashboardDetail  =   (id = null) => {
        
        const subAssemblyId     =   id ? id : this.props.subAssemblyId; 

        this.setState({
            dashboard_loading       :   true,
            subAssemblyId,
        });

        HttpAPICall.withAthorization('GET',  IAM_SUBASSEMBLY_URL + '/widget/' + subAssemblyId, this.props.access_token, {}, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                widgetData      :   respData,
                dashboardTabShow: true
            })
        }).then(() => this.setState({dashboard_loading: false}));
    }

    subAssemblyDetail   =   (id = null) => {
        
        const subAssemblyId     =   id ? id : this.props.subAssemblyId; 

        this.setState({
            loadingDetail : true,
            detailShow    : true,
            subAssemblyId,
        });

        HttpAPICall.withAthorization('GET',  IAM_SUBASSEMBLY_URL + '/detail/' + subAssemblyId, this.props.access_token, {need_documents:"Y"}, {}, (resp) => {
            let respData = resp.data.data;
            this.setState({
                viewSubAssemblyDetail   :   respData,
            })
            if(this.props.viewSubAssemblyDetail){
                this.props.viewSubAssemblyDetail(respData);
            }
        }).then(() => this.setState({loadingDetail: false}));
    }   

    handleDocumentModal =   () => {
        this.documentModalRef.current.showModalInit();
    }

    handleTicketTab = () => {
        this.setState({ ticketTabShow: true });
    }

    handleProcurementTab = () => {
        this.setState({ procurementTabShow: true });
    }

    handleConsumptionTab = () => {
        this.setState({ consumptionTabShow: true });
    }
    

    handleAssetTab = () => {
        if(!this.state.assetLinkingLoaded) {
            this.getAssetLinkinglisting();
        }
        this.setState({ assetTabShow: true });
    }

    handleSiteTab = () => {
        if(!this.state.siteTransitionLoaded) {
            this.getSiteLinking();
        }
        this.setState({ siteTabShow: true });
    }

    handleDashboardTab = () => {
        this.setState({ dashboardTabShow: true });
    }

    deleteDocument              =   (doc_id)  =>  {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization('DELETE', IAM_SUBASSEMBLY_URL + '/delete_document/' + doc_id, this.props.access_token, {},{} ,(response) => {
                    toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
                    this.subAssemblyDetail(this.state.subAssemblyId);
                }).then(() => { });
            }
        });
    }

    viewLinkedAssetDetailInit   =   (id)      =>  {
        this.linkedAssetDetailModal.show()
        this.setState({loadingAssetDetail : true})
        HttpAPICall.withAthorization('GET',  IAM_SUBASSEMBLY_URL + '/linked_asset_history/' + id, this.props.access_token, {}, {}, (resp) => {
            let respData = resp.data.data;
            this.setState({
                linkedAssetDetail   :   respData,
            });
        }).then(() => this.setState({loadingAssetDetail: false}));
    }

    delinkAssetModalInit        =   (id)      =>      {
        this.linkAssetModalRef.current.linkAssetModalInit(this.state.viewSubAssemblyDetail,'delink',id)
    }

    detailJsx = () => {
        const viewDetail = this.state.viewSubAssemblyDetail;
        return (
            <Ax>
                <div className="tab_content_wrapper"><span className="content_heading">Sub Assembly Detail</span></div>
                <table className="table table-hover table-bordered  table-responsive bg-white mt-2 ">
                    <tbody>
                        <tr>
                            <td className="fs14 fw-normal" style={{ "width": "25%" }}>Name</td>
                            <td className="fs14 fw500" >{viewDetail ? viewDetail.name : ''}</td>
                        </tr>
                        <tr>
                            <td className="fs14 fw-normal" style={{ "width": "25%" }}>Code</td>
                            <td className="fs14 fw500" >{viewDetail ? viewDetail.card_number : ''}</td>
                        </tr>
                        <tr>
                            <td className="fs14 fw-normal" style={{ "width": "25%" }}>Manufacturer Name</td>
                            <td className="fs14 fw500" >{viewDetail && viewDetail.manufacturer ? viewDetail.manufacturer.name  : ''}</td>
                        </tr>
                        <tr>
                            <td className="fs14 fw-normal" style={{ "width": "25%" }}>Tags</td>
                            <td className="fs14 fw500 " >
                                {
                                    viewDetail
                                        ? viewDetail.sub_assembly_tags && viewDetail.sub_assembly_tags.length > 0 && viewDetail.sub_assembly_tags.map((tag, i) => <span className="badge bg-secondary">{tag}</span>)
                                        : ''
                                }
                            </td>
                        </tr>
                        <tr>
                            <td className="fs14 fw-normal" style={{ "width": "25%" }}>Serial Number</td>
                            <td className="fs14 fw500">{viewDetail ? viewDetail.serial_number : ''}</td>
                        </tr>
                        <tr>
                            <td className="fs14 fw-normal" style={{ "width": "25%" }}>Category</td>
                            <td className="fs14 fw500" >{viewDetail && viewDetail.category ? viewDetail.category.name : ''}</td>
                        </tr>
                        <tr>
                            <td className="fs14 fw-normal" style={{ "width": "25%" }}>Purchase Date</td>
                            <td className="fs14 fw500" >{viewDetail ? (viewDetail.purchase_date &&  DateService.dateTimeFormat(viewDetail.purchase_date, 'DD-MMM-YYYY')) : ''}</td>
                        </tr>
                        <tr>
                            <td className="fs14 fw-normal" style={{ "width": "25%" }}>Purchase Price</td>
                            <td className="fs14 fw500" >{viewDetail ? viewDetail.purchase_price : ''}</td>
                        </tr>
                        <tr>
                            <td className="fs14 fw-normal" style={{ "width": "25%" }}>Current Status</td>
                            <td className="fs14 fw500" >
                                <Status color={viewDetail && viewDetail.status && viewDetail.status.color_code }>
                                {
                                    viewDetail 
                                    ?
                                    viewDetail.status && viewDetail.status.name
                                    : ''
                                }
                                </Status>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="tab_content_wrapper mt-2">
                    <span className="content_heading">Additional Attributes</span>
                </div>
                <table className="table table-hover table-bordered  table-responsive bg-white mt-2 ">
                    <tbody>
                        {
                          viewDetail &&  viewDetail.additional_attributes && viewDetail.additional_attributes.length > 0 ?
                            viewDetail.additional_attributes.map((attribute, index) => {
                                return (<tr key={index}>
                                    <td className="fs14 fw-normal" style={{ "width": "25%" }}>{attribute.name}</td>
                                    <th className="fs14 fw500">{attribute.value_display ? attribute.value_display : "-"}</th>
                                </tr>)
                            })
                            : null
                        }
                    </tbody>
                </table>
                <div className="tab_content_wrapper mt-2"><span className="content_heading">Current Site</span></div>
                <table className="table table-hover table-bordered  table-responsive bg-white mt-2 ">
                    <tbody>
                        <tr>
                            <td className="fs14 fw-normal" style={{ "width": "25%" }}>Site</td>
                            <td className="fs14 fw500" >
                                {viewDetail && viewDetail.site && viewDetail.site.site_name + " (" + viewDetail.site.site_code + ")" }
                            </td>
                        </tr>
                        <tr>
                            <td className="fs14 fw-normal" style={{ "width": "25%" }}>Linked From</td>
                            <td className="fs14 fw500" >
                                {
                                    viewDetail && viewDetail.site_since_date && DateService.dateTimeFormat(viewDetail.site_since_date, 'DD-MMM-YYYY')
                                }   
                            </td>
                        </tr>
                    </tbody>
                </table>
                
                <div className="tab_content_wrapper mt-2">
                    <span className="content_heading">Sub Assembly Document</span>
                    {
                        <span className="text-end dropdown">
                        {this.props.permissions.includes('sub_assembly_doc_add') && <button type="button" onClick={() => this.handleDocumentModal()} className="btn btn-light">
                        <TapIcon.FontAwesomeIcon className="text-muted" icon={TapIcon.faPlus} />
                        </button>}
                        </span>
                    }
                </div>
                <table className="table table-bordered bg-white mt-2 pb-5">
                    <thead className="table-secondary">
                        <tr>
                            <td style={{ "width": "5%" }}>S.No</td>
                            <td style={{ "width": "35%" }}>Name</td>
                            <td style={{ "width": "30%" }}>Number</td>
                            <td style={{ "width": "10%" }}>View</td>
                            <td style={{ "width": "10%" }}>Download</td>
                            <td style={{ "width": "10%" }}>Delete</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            viewDetail && viewDetail.documents && viewDetail.documents.length > 0 ? viewDetail.documents.map((d,i) => {
                                return <tr className='text-center' key={i}>
                                    <td>{i + 1}</td>
                                    <td>{d.name}</td>
                                    <td>{d.number}</td>
                                    <td scope="col" className="text-center" style={{ "width": "10%" }}>
                                        <Link role="button"
                                            target='_blank'
                                            to={{pathname : d.document}}
                                            className={[d.view_permission  || this.props.permissions.includes('sub_assembly_doc_view') ? '' : 'disabled-link'].join(' ')}
                                            title={d.view_permission || this.props.permissions.includes('sub_assembly_doc_view') ? '' : 'You do not have permission to perform this action'}
                                            style={{ "pointerEvents": "all" }}
                                        > <TapIcon.FontAwesomeIcon icon={TapIcon.faEye}  /></Link>
                                    </td>
                                    <td scope="col" className="text-center" style={{ "width": "10%" }}>
                                        <Link role="button"
                                            target='_blank'
                                            to={{pathname : d.download_link}}
                                            className={[d.downlaod_permission || this.props.permissions.includes('sub_assembly_doc_view') ? '' : 'disabled-link'].join(' ')}
                                            title={d.downlaod_permission || this.props.permissions.includes('sub_assembly_doc_view') ? '' : 'You do not have permission to perform this action'}
                                            style={{ "pointerEvents": "all" }}
                                        > <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload}  /></Link>
                                    </td>
                                    <td scope="col" className="text-center" style={{ "width": "10%" }}>
                                        <a role="button"
                                            onClick={() => {
                                                if (this.props.permissions.includes('sub_assembly_doc_delete')) {
                                                   return this.deleteDocument(d.doc_id)
                                               }
                                            }}
                                            className={[this.props.permissions.includes('sub_assembly_doc_delete') ? '' : 'disabled-link'].join(' ')}
                                            title={!this.props.permissions.includes('sub_assembly_doc_delete') ? 'You do not have permission to perform this action' : ''}
                                            style={{ "pointerEvents": "all" }}
                                        > <TapIcon.FontAwesomeIcon icon={TapIcon.faTrashAlt}  /></a>
                                    </td>
                                </tr>
                            })
                            : <tr><td className='text-center' colSpan="6">No Document Found</td></tr>
                        }
                    </tbody>
                </table>
            </Ax>
        )
    }

    getSiteLinking      =       (id=null)   =>      {
        const subAssemblyId     =   id ? id : this.props.subAssemblyId; 
        this.setState({site_listing_loading : true});
        HttpAPICall.withAthorization('GET',  IAM_SUBASSEMBLY_URL + '/site_transaction/' + subAssemblyId, this.props.access_token, {}, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                siteTransitionList      :   respData,
                siteTransitionLoaded    :   true,
            })
        }).then(() => this.setState({site_listing_loading: false}));

    }   

    getAssetLinkinglisting      =       (id=null,page=1)      =>      {
        const subAssemblyId     =   id ? id : this.props.subAssemblyId; 
        this.setState({asset_linking_loading : true});
            HttpAPICall.withAthorization('GET',  IAM_SUBASSEMBLY_URL + '/linked_asset', this.props.access_token, {sub_assembly_id : subAssemblyId,page:page}, {}, (resp) => {
                let respData = resp.data;
                this.setState({
                    asset_linking_data    :   respData.data,
                    assetLinkingLoaded    :   true,
                    assetLinkingMeta        :   respData.meta
                })
            }).then(() => this.setState({asset_linking_loading: false}));
    }

    deleteAssetLinking                      =   (id)  =>  {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization('DELETE', IAM_SUBASSEMBLY_URL + '/asset_linking_history/' + id , this.props.access_token, {},{} ,(response) => {
                    toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
                    this.getAssetLinkinglisting(this.state?.viewSubAssemblyDetail?.enc_id)
                }).then(() => { });
            }
        });
    }

    siteTransitionJsx = () => {
        return (
            <div className="tab_content_header">
            <table className="table table-bordered bg-white align-items-center  table-sm table-hover my-3" id="settingsTable">
                <thead className="table-secondary">
                    <tr className="text-center">
                        <th scope="col" style={{ width: "5%" }} >S.No</th>
                        <th scope="col" style={{ width: "25%" }}>From</th>
                        <th scope="col" style={{ width: "25%" }}>To</th>
                        <th scope="col" style={{ width: "25%" }}>Site </th>
                        <th scope="col" style={{ width: "15%" }} >No of Days</th>
                    </tr>
                </thead>
                <tbody>
                {
                    this.state.site_listing_loading
                    ?
                    <tr><td className="text-center" colSpan={6}><Loader/></td></tr>
                    :
                    this.state.siteTransitionList && this.state.siteTransitionList.length > 0 ? this.state.siteTransitionList.map((data, index) => {
                        let date1 = data.from ? moment(data.from) : moment(new Date());
                        let date2 = data.till ? moment(data.till) : moment(new Date());
                        let days = date2.diff(date1, 'days')
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                {data.from ? DateService.dateTimeFormat(data.from, 'DD-MMM-YYYY HH:mm A') : '-'}
                                </td>
                                <td>
                                {data.till ? DateService.dateTimeFormat(data.till, 'DD-MMM-YYYY HH:mm A') : 'Till Date'}
                                </td>
                                <td>{data.site_name ? data.site_name : '-'}</td>
                                <td>{days ? days : 0} Days</td>

                            </tr>
                        )
                       
                    }) :  (<tr><td className='text-center' colSpan={6}>No Record</td></tr>)
                }
                    
                </tbody>
            </table>
            </div>
        );
    }

    calculateTotalDays = (fromDate, toDate) => {
        if (moment(fromDate, 'DD-MMM-YYYY').isValid() && moment(toDate, 'DD-MMM-YYYY').isValid()) {
            const startDate = moment(fromDate, 'DD-MMM-YYYY');
            const endDate = moment(toDate, 'DD-MMM-YYYY');
            const diffDays = endDate.diff(startDate, 'days');
            return diffDays;
        }
        return '-';
    }

    assetLinkingJsx     =   ()      =>  {
        return(
            <div className="tab_content_header">
                
                <table className="table table-bordered bg-white align-items-center table-sm table-hover my-3" id="settingsTable">
                    <thead className="table-secondary">
                        <tr className="text-center">
                            <th scope="col" style={{ width: "5%" }}>S.No</th>
                            <th scope="col" style={{ width: "20%" }}>Asset</th>
                            <th style={{ width: "15%" }}>Meter</th>
                            <th style={{ width: "20%" }}>From</th>
                            <th style={{ width: "20%" }}>To</th>
                            <th style={{ width: "10%" }}>Total Days</th>
                            <th style={{ width: "10%" }}>Total Running</th>
                            <th style={{ width: "5%" }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.asset_linking_loading ? (
                            <tr>
                                <td className="text-center" colSpan={8}><Loader /></td>
                            </tr>
                        ) : (
                            this.state.asset_linking_data && this.state.asset_linking_data.length > 0 ? (
                                this.state.asset_linking_data.map((data, index) => {
                                    return data.linking_cl && data.linking_cl.length > 0 ? (
                                        data.linking_cl.map((cl, key) => {
                                            const latestReading = data?.latest_cl?.find(latest => latest.key === cl.key);
                                            const delinkReading = data?.delinking_cl?.find(latest => latest.key === cl.key);
                                            const reading = latestReading && latestReading.reading ? latestReading.reading : 0;
                                            const From = cl.label == "Date" ? cl.reading : "";

                                            const To   = delinkReading && delinkReading.label == "Date" ? delinkReading.reading : latestReading && latestReading.label == "Date" ? latestReading.reading : "";
                                            
                                            let rd = data.reading_display.find(rd => rd.meter === cl.label);

                                            const totalRunning = rd ? rd.running : null ;
                                            
                                            return (
                                                <tr key={`${index}-${key}`}>
                                                    {key === 0 ? (
                                                        <>
                                                             <td className="align-middle text-center" rowSpan={data.linking_cl.length}>{this.state.assetLinkingMeta ? this.state.assetLinkingMeta.from + index : index + 1}</td>
                                                            <td className="align-middle" rowSpan={data.linking_cl.length}>{data.asset ? <span>{data.asset.name} ({data.asset.asset_code})</span> : null}</td>
                                                        </>
                                                    ) : null}
                                                    <td className="text-center">{cl.label}</td>
                                                    <td className="text-center" >{cl.reading} {cl.unit}</td>
                                                    <td className="text-center">
                                                        {data && !data.end_date ?
                                                            cl.key === latestReading.key ? latestReading.label == "Date" ? "Till Now" : latestReading.reading : cl.reading
                                                            :
                                                            data.delinking_cl.map(delinking => delinking.key === cl.key && delinking.reading)
                                                        } {cl.unit}
                                                    </td>
                                                    <td >{From && To ? <span>{this.calculateTotalDays(From,To)} Days</span> : ""}</td>
                                                    <td className="text-center">{ rd ? <span>{totalRunning} {cl.unit}</span> : "-"}</td>
                                                    {key === 0 ? (
                                                        <td rowSpan={data.linking_cl.length} className="text-center">
                                                            <TapIcon.imageIcon icon={TapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-3" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                                            <ul className="dropdown-menu">
                                                                <li><Link className="dropdown-item" onClick={() => this.viewLinkedAssetDetailInit(data.id)}>View</Link></li>
                                                                {data && !data.end_date && this.state.viewSubAssemblyDetail?.status?.id !== 2 && this.props.permissions.includes('iam-sub-assembly-asset-manage') &&   <li><Link className="dropdown-item" onClick={() => this.delinkAssetModalInit(data.asset_id)}>De-link</Link></li>}
                                                                {this.state.assetLinkingMeta && this.state.assetLinkingMeta.current_page !== 2 && this.props.permissions.includes('iam-sub-assembly-asset-manage') &&  index === 0 && <li><Link className="dropdown-item" onClick={() => this.deleteAssetLinking(data.id)}>Delete</Link></li>}
                                                            </ul>
                                                        </td>
                                                    ) : null}
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr key={index}>
                                            <td className="text-center" colSpan={6}>No Linking</td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td className="text-center" colSpan={8}>No Record</td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>

            <DisplayListPagination
                meta={this.state.assetLinkingMeta}
                onPageChange={(e) => this.getAssetLinkinglisting(this.props.subAssemblyId,e.selected + 1)}
            />
            </div>
        )
    }

    assetLinkingDetailJsx = ()      =>      {
        let detail = this.state.linkedAssetDetail;
        let sub_assembly_detail = this.state.viewSubAssemblyDetail;
        return (<div className="modal fade" id="linkedAssetDetailModal" tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="searchAssetModalLabel">Linked Asset Detail</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
                    </div>
                    <div className='modal-body'>
                        {this.state.loadingAssetDetail ? <Loader />
                            : <>
                                <table className="table table-hover table-bordered  table-responsive bg-white">
                                    <tbody>
                                        <tr>
                                            <td style={{ width: "33%" }}>Sub Assembly</td>
                                            <th>{sub_assembly_detail && sub_assembly_detail.name} </th>

                                        </tr>
                                        <tr>
                                            <td style={{ "width": "25%" }}>Code</td>
                                            <th >{sub_assembly_detail && sub_assembly_detail.card_number ? sub_assembly_detail.card_number : ''}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ "width": "25%" }}>Asset</td>
                                            <th>{detail && detail.asset && detail.asset.name + " (" + detail.asset.asset_code + ")"}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ "width": "25%" }}>Linked From Date</td>
                                            <th>{detail && detail.start_date && DateService.dateTimeFormat(detail.start_date, 'DD-MMM-YYYY HH:mm A')}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ "width": "25%" }}>Linked Till Date</td>
                                            <th>{detail && detail.end_date ? DateService.dateTimeFormat(detail.end_date, 'DD-MMM-YYYY HH:mm A') : "Till Now"}</th>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className="tab_content_wrapper mt-2"><span className="content_heading">Linking Detail</span></div>
                                <table className="table table-hover table-bordered  table-responsive bg-white my-2">
                                    <thead className='text-center'>
                                        <th style={{ width: "5%" }}>S.No</th>
                                        <th style={{ width: "25%" }}>Meter</th>
                                        <th style={{ width: "25%" }}>CL at Linking</th>
                                        <th style={{ width: "25%" }}>{detail && detail.end_date ? "CL at Delinking" : "Latest Counterlog"}</th>
                                        <th style={{ width: "10%" }}>Total Running</th>
                                    </thead>
                                    <tbody>
                                        {detail && detail.linking_cl && detail.linking_cl.length > 0 ? (
                                            detail.linking_cl.map((cl, index) => {
                                                const latestReading = detail.latest_cl.find(latest => latest.key === cl.key);
                                                const delinkReading =   detail.delinking_cl.find(latest => latest.key === cl.key)
                                                let rd = detail.reading_display.find(rd => rd.meter === cl.label);
                                                const totalRunning = rd ? rd.running : null ;
                                                return (
                                                    <tr key={index}>
                                                        <td className='text-center'>{index + 1}</td>
                                                        <td>{cl.label}</td>
                                                        <td>{cl.reading} {cl.unit}</td>
                                                        <td>
                                                            {detail && !detail.end_date ?
                                                                cl.key === latestReading.key ? latestReading.reading : cl.reading
                                                                :
                                                                detail.delinking_cl.map(delinking => delinking.key === cl.key && delinking.reading)
                                                            } {cl.unit}
                                                        </td>
                                                        <td>{rd ? <span>{totalRunning} {cl.unit}</span> : "-"}</td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr><td className='text-center' colSpan={5}>No Counterlog</td></tr>
                                        )}

                                    </tbody>
                                </table>
                                {detail && detail.reading_display && detail.reading_display.length > 0 && detail.reading_display.map((rd,k) => {
                                    return(<div className='form-text' key={k}><sup>*</sup>{rd.label} meter is tracked on the basis of {rd.meter}</div>)
                                })}
                                <div className="tab_content_wrapper mt-2"><span className="content_heading">Linked Details</span></div>
                                <table className="table table-hover table-bordered  table-responsive bg-white my-2">
                                    <tbody>
                                        <tr>
                                            <td style={{ width: "33%" }}>Linking Date</td>
                                            <th>{detail && detail.linked_on ? detail.linked_on : ""}</th>

                                        </tr>
                                        <tr>
                                            <td style={{ width: "33%" }}>Linking Done By</td>
                                            <th>{detail && detail.linking_by ? detail.linking_by.full_name : ""}</th>

                                        </tr>
                                        {detail && detail.delinking_by && <>
                                            <tr>
                                                <td style={{ width: "33%" }}>De-Linking Date</td>
                                                <th>{detail && detail.delinked_on ? detail.delinked_on : "-"}</th>
                                            </tr>

                                            <tr>
                                                <td style={{ width: "33%" }}>De-Linking Done By</td>
                                                <th>{detail && detail.delinking_by ? detail.delinking_by.full_name : "-"}</th>
                                            </tr>
                                        </>}

                                    </tbody>
                                </table>
                            </>
                        }

                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>)
    }

    dashboardJsx        =       ()      =>      {
        let {widgetData}        =   this.state;
        return(<Ax>
            <div className="tab_content_wrapper mt-2"><span className="content_heading">Linking Detail</span></div>
            <table className="table table-hover table-bordered  table-responsive bg-white my-2">
                <tbody>
                    <tr>
                        <td style={{ width: "33%" }}>Asset Linked</td>
                        <th>{widgetData && JSON.stringify(widgetData.asset) !== JSON.stringify({}) ? "Yes" : "No"}</th>
                    </tr>
                    {widgetData && JSON.stringify(widgetData.asset) !== JSON.stringify({}) && <>
                        <tr>
                            <td style={{ width: "33%" }}>Asset</td>
                            <th>{widgetData.asset.name} </th>
                        </tr>
                        <tr>
                            <td style={{ width: "33%" }}>Linking Date</td>
                            <th>{widgetData.linking_date} </th>
                        </tr>
                        <tr>
                            <td style={{ width: "33%" }}>CounterLog</td>
                            <th>{widgetData.linking_cl && widgetData.linking_cl.length > 0 && widgetData.linking_cl.map((lk,k) => {return(<div key={k}>{lk.label} : {lk.reading} {lk.unit}</div>)})} </th>
                        </tr>
                    </>}

                    
                </tbody>
            </table>
            <div className="tab_content_wrapper mt-2"><span className="content_heading">Running Detail</span></div>
                    <table className="table table-hover table-bordered  table-responsive bg-white mt-2">
                        <thead className='text-center table-secondary'>
                            <th style={{ width: "5%" }}>S.No</th>
                            <th style={{ width: "25%" }}>Meter</th>
                            <th style={{ width: "20%" }}>Current Tracking Meter</th>
                            <th style={{ width: "25%" }}>Current Running</th>
                            <th style={{ width: "25%" }}>LifeTime Running</th>
                        </thead>
                        <tbody>
                        {widgetData && widgetData.total_running && widgetData.total_running.length > 0 && widgetData.total_running.map((data, index) => {
                                 let currentRunningValue = widgetData.current_running.find(item => item.unit === data.unit);
                                 let running = currentRunningValue ? currentRunningValue.running : null;
                                let label = data.unit == "Hr" ? "Hour Meter" : data.unit == "Km" ? "Odo Meter" : "Oeration Cycle"
                                return (
                                    <tr key={index} className='text-center'>
                                        <td>{index + 1}</td>
                                        <td>{label}</td>
                                        <td >{currentRunningValue  ? <span>{currentRunningValue.meter}</span> : "-"}</td>
                                        <td >{currentRunningValue  ? <span>{currentRunningValue.running}  {data.unit}</span> : "-"}</td>
                                        <td>{data.runing} {data.unit}</td>
                                    </tr>
                                )
                            })}

                          
                        </tbody>
                    </table>
                    {this.detailJsx()}

        </Ax>)
    }

    render() {
        return (
            <Ax>
                {this.state.dashboard_loading ? (
                    <div className="text-center bg-white">
                        <Loader />
                    </div>
                ) : (
                    <section className="item_view_container bg-white">
                        <ul className="nav nav-tabs" id="myTab" role="tablist">

                            {!this.props?.showOnlyAssetLinking && <li className="nav-item" role="presentation">
                                <button className="nav-link active" id="dashboard-tab" data-bs-toggle="tab" data-bs-target="#dashboard"
                                    type="button" role="tab" aria-controls="dashboard" aria-selected="true"
                                    ref={this.dashboardVoucherBtnRef}
                                    onClick={this.handleDashboardTab}>
                                    Detail
                                </button>
                            </li>}

                            {this.props.permissions.includes('iam-sub-assembly-site-list') && !this.props?.showOnlyAssetLinking && <li className="nav-item" role="presentation">
                                <button className="nav-link" id="site-tab" data-bs-toggle="tab" data-bs-target="#site"
                                    type="button" role="tab" aria-controls="site" aria-selected="true"
                                    ref={this.siteVoucherBtnRef}
                                    onClick={this.handleSiteTab}>
                                    Site Transition
                                </button>
                            </li>}
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="asset-tab" data-bs-toggle="tab" data-bs-target="#asset"
                                    type="button" role="tab" aria-controls="asset" aria-selected="true"
                                    ref={this.assetVoucherBtnRef}
                                    onClick={this.handleAssetTab}>
                                    Asset Linking
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="ticket-tab" data-bs-toggle="tab" data-bs-target="#ticket"
                                    type="button" role="tab" aria-controls="ticket" aria-selected="true"
                                    ref={this.ticketVoucherBtnRef}
                                    onClick={this.handleTicketTab}>
                                    Ticket
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="procurement-tab" data-bs-toggle="tab" data-bs-target="#procurement"
                                    type="button" role="tab" aria-controls="procurement" aria-selected="true"
                                    ref={this.procurementVoucherBtnRef}
                                    onClick={this.handleProcurementTab}>
                                    Procurement Cycle
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="consumption-tab" data-bs-toggle="tab" data-bs-target="#consumption"
                                    type="button" role="tab" aria-controls="consumption" aria-selected="true"
                                    ref={this.consumptionVoucherBtnRef}
                                    onClick={this.handleConsumptionTab}>
                                    Consumption Cycle
                                </button>
                            </li>

                        </ul>
                        <div className="tab-content" id="myTabContent">

                            <div className="tab-pane" id="site" role="tabpanel" aria-labelledby="site-tab">
                                {this.state.site_listing_loading ?
                                    <Loader />
                                    : this.state.siteTransitionLoaded && this.siteTransitionJsx()}
                            </div>
                            <div className={`tab-pane  ${this.props.showOnlyAssetLinking ? "show active" : ""}`}
                                id="asset" role="tabpanel" aria-labelledby="asset-tab">
                                {this.state.asset_linking_loading ?
                                    <Loader />
                                    : this.state.assetLinkingLoaded && this.assetLinkingJsx()}
                            </div>
                            <div className={`tab-pane  ${!this.props?.showOnlyAssetLinking ? " show active" : ""}`}
                                id="dashboard" role="tabpanel" aria-labelledby="dashboard-tab">
                                <div className="tab_content_header pb-5">
                                    {this.state.dashboardTabShow && this.dashboardJsx()}
                                </div>
                            </div>
                            <div className="tab-pane" id="ticket" role="tabpanel" aria-labelledby="ticket-tab">
                                <div className="mt-2 ps-2 ">
                                    {this.state.ticket_loading ? <Loader /> :
                                        this.state.ticketTabShow && <TicketTransactionList />}
                                </div>
                            </div>
                            <div className="tab-pane" id="procurement" role="tabpanel" aria-labelledby="procurement-tab">
                                <div className="pe-2 mx-2" style={{ height: "100%", maxHeight: "500px", overflowY: "scroll", overflowX: "hidden" }}>
                                    {this.state.procurement_loading ? <Loader /> :
                                        this.state.procurementTabShow && <ProcurementTab subAssemblyId={this.state.viewSubAssemblyDetail} />}
                                </div>

                            </div>
                             <div className="tab-pane" id="consumption" role="tabpanel" aria-labelledby="consumption-tab">
                                    <div className="pe-2 mx-2" style={{ height: "100%", maxHeight: "500px", overflowY: "scroll", overflowX: "hidden" }}>
                                        {this.state.consumption_loading ? <Loader /> :
                                            this.state.consumptionTabShow && <ConsumptionCycleTabContainer
                                                id={this.state.viewSubAssemblyDetail?.enc_id}
                                                config={{
                                                    type: 'sub_assembly',
                                                    showDemand: true,
                                                    showAllocation: true,  
                                                    showConsumption: true,
                                                    showAddButtons: false, 
                                                    showTotalSummary: false,
                                                }}
                                            />}
                                </div>

                            </div>

                        </div>

                    </section>
                )}


                {this.assetLinkingDetailJsx()}
                <LinkingModal ref={this.linkAssetModalRef} afterSubmitForm={(id) => { this.subAssemblyDetail(id); this.getDashboardDetail(id); this.props.viewSubAssemblyDetail(id); this.getAssetLinkinglisting(id) }} />
                <SubAssemblyDocumentModal ref={this.documentModalRef} subAssemblyDetail={this.state.viewSubAssemblyDetail} getSubAssemblyViewDetails={(id) => this.subAssemblyDetail(id)} />
            </Ax>
        )
    }
}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        permissions             :   state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : []
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(SubAssemblyDetail);